import "./Button.scss";

import clsx from "clsx";
import React, { MouseEventHandler, ReactNode } from "react";
import { Link, LinkProps } from "react-router-dom";
import { FCC } from "types";

type ButtonType = "submit" | "button";

type ButtonProps = {
  onClick?: MouseEventHandler;
  className?: string;
  disabled?: boolean;
  dataTestid?: string;
  type?: ButtonType;
  fullWidth?: boolean;
};

export const Button: FCC<ButtonProps> = ({
  onClick = () => null,
  className,
  children,
  disabled,
  dataTestid,
  type,
  fullWidth,
}) => {
  return (
    <div
      id="click-button-wrapper"
      className={clsx("font-semibold", fullWidth && "flex w-full")}
    >
      <button
        className={clsx(
          className,
          "w-full",
          !fullWidth && "smPlus:max-w-fit",
          disabled && "disabled",
        )}
        type={type}
        tabIndex={disabled ? -1 : 0}
        data-testid={dataTestid}
        onClick={disabled ? () => null : onClick}
      >
        {children}
      </button>
    </div>
  );
};

type AnchorProps = {
  href?: string;
  disabled?: boolean;
  className?: string;
  label?: string;
  target?: "_self" | "_blank" | "_parent" | "_top";
};
export const Anchor = ({
  href = "/",
  disabled = false,
  className = "",
  label = "",
  target = "_blank",
}: AnchorProps) => {
  return (
    <div id="navigate-button-wrapper" className="button-wrapper font-semibold">
      <a
        aria-label={label}
        href={href}
        className={clsx(className, disabled && "disabled")}
        target={target}
        rel="noreferrer"
      >
        {label}
      </a>
    </div>
  );
};

export const StyledLink: FCC<
  LinkProps &
    React.RefAttributes<HTMLAnchorElement> & {
      disabled?: boolean;
      variant?: "default" | "outlined";
      "data-testid"?: string;
    }
> = (props) =>
  props.disabled ? (
    <div className="fakebutton-wrapper button-wrapper font-semibold">
      <div
        data-testid={props["data-testid"] ?? undefined}
        className={clsx(
          "fakebutton disabled mt-14 w-full smPlus:w-fit",
          props.variant === "outlined" ? "fakebutton-outlined" : "accent",
        )}
      >
        {props.children}
      </div>
    </div>
  ) : (
    <div id="styled-link-wrapper" className="button-wrapper font-semibold">
      <Link {...props}>{props.children}</Link>
    </div>
  );

export const SubmitButton = ({
  label,
  className,
  disabled,
  dataTestid,
}: {
  label: ReactNode;
  className?: string;
  disabled?: boolean;
  dataTestid?: string;
}) => (
  <div
    id="submit-button-wrapper"
    data-testid={dataTestid}
    className="button-wrapper font-semibold"
  >
    <Button
      type="submit"
      className={clsx(
        className,
        "relative w-full smPlus:max-w-fit",
        disabled && "disabled",
      )}
      fullWidth
    >
      {label}
    </Button>
  </div>
);
